import StorageService from "../session/storage.service";
import StorageType from "../session/storage.enum";
import AppSetting from "../../common/constants/appsetting.constant";
import axios from "axios";
import moment from "moment";
import Utilities from "../commonservice/utilities";

const SoapNotesService = {
  loggedInUserData: {},

  getLoggedInData() {
    return JSON.parse(StorageService.get('session', "userDetails")
    );
  },

  findSoapNotes(reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url;
    url = AppSetting.soapNotes.findSoapNotes.replace(
      "{providerId}",
      loggedInUserData.parentId
    );
    // console.log(this.buildQuery(reqObj))
    url = `${url}${this.buildQuery(reqObj)}`;
    return axios.get(url, reqObj)
      .then(res => {
        return res.data
      })
      .catch(err => { console.log(err) })
  },


  getSoapNotesById(patientId, soapNotesId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.soapNotes.editSoapNotes
      .replace("{providerId}", loggedInUserData.parentId)
      .replace("{patientId}", patientId)
      .replace("{soapNotesId}", soapNotesId);
    return axios.get(url)
      .then((res) => {
        return res.data
      })
      .catch(err => { console.log(err) })

  },

  addSoapNotes(patientId, reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.soapNotes.addSoapNotes
      .replace("{providerId}", loggedInUserData["parentId"])
      .replace("{patientId}", patientId);
    return axios.post(url, reqObj)
      .then(a => { return a })
      .catch(err => { return err })
  },

  editSoapNotes(patientId, reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.soapNotes.editSoapNotes
      .replace("{providerId}", loggedInUserData["parentId"])
      .replace("{patientId}", patientId)
      .replace("{soapNotesId}", reqObj.id);
    return axios.put(url, reqObj)
      .then((a) => { return a })
      .catch(err => { return err })
  },

  buildQuery(data) {
    let queryData = "";
    for (const prop in data) {
      if (
        data[prop] !== "" &&
        data[prop] !== "undefined" &&
        data[prop] !== null
      ) {
        if (queryData === "") {
          queryData = "?" + prop + "=" + data[prop];
        } else {
          queryData += "&" + prop + "=" + data[prop];
        }
      }
    }
    return queryData;
  }
}

export default SoapNotesService